export default class HocrProofreader {
    constructor(config) {
        this.config = config;
        this.pageWidthOutlierRatio = 1.35;
    }

    init() {
        if (document.querySelector("#" + this.config.layoutContainer + " .layout")) {
            console.log("layout-svg has already been created")
        } else {
            this.layoutSvg = this.createSvgElem('svg', { 'class': 'layout' });
            this.layoutImages = this.createSvgElem('g', { 'class': 'images' });
            this.layoutSvg.appendChild(this.layoutImages);

            // this.layoutWords = this.createSvgElem('g', {'class': 'words'});
            // this.layoutSvg.appendChild(this.layoutWords);
            this.layoutRects = this.createSvgElem('g', { 'class': 'rects', 'id': 'layout-rects' });
            this.layoutSvg.appendChild(this.layoutRects);

            this.layoutContainer = document.getElementById(this.config.layoutContainer);
            this.layoutContainer.appendChild(this.layoutSvg);
            //this.layoutContainer.style.overflow = 'scroll';
        }
        if (document.querySelector("#" + this.config.editorContainer + " .editor")) {
            console.log("editor-iframe has already been created")
        } else {
            this.editorIframe = this.createElem('iframe', { 'class': 'editor', 'frameborder': 0 });

            var editorContainer = document.getElementById(this.config.editorContainer);
            editorContainer.appendChild(this.editorIframe);
        }
        var self = this;
        self.hoveredNode = null;
        self.mousePosition = null;

        // init some defaults:
        this.currentPage = null;
        // this.toggleLayoutImage();
        this.setZoom('page-width');
    }

    createElem(name, attributes) {
        var node = document.createElement(name);
        for (var name in attributes) {
            node.setAttribute(name, attributes[name]);
        }
        return node;
    }

    createSvgElem(name, attributes) {
        var node = document.createElementNS('http://www.w3.org/2000/svg', name);
        for (var name in attributes) {
            node.setAttribute(name, attributes[name]);
        }
        return node;
    }

    removeChildren(node) {
        while (node.hasChildNodes()) {
            node.removeChild(node.lastChild);
        }
    }

    setHocr(hocr, images, onDone = () => { }) {
        if (!hocr || !images)
            return;

        console.log("Setting Hocr");

        this.layoutContainer = document.getElementById(this.config.layoutContainer);
        if (!this.layoutContainer)
            return;
        this.init();
        var hocrDoc = this.editorIframe.contentDocument;

        // TODO: use baseUrl for images/components in hOCR - use <base>?
        hocrDoc.open();
        hocrDoc.write(hocr);
        hocrDoc.close();

        this.removeChildren(this.layoutImages);
        this.removeChildren(this.layoutRects);
        this.renderAllPages(images);

        if (onDone) onDone();
    }

    renderAllPages(images) {
        console.log('Will render all pages');
        let pageNode;
        const hocrDoc = this.editorIframe.contentDocument;

        pageNode = hocrDoc.body.firstElementChild;
        let pages = [];
        while (pageNode) {
            if (pageNode.classList.contains('ocr_page')) {
                pages.push(this.getPageMetrics(pageNode));
                console.log('Will render page: ' + pageNode.id);
            }

            pageNode = pageNode.nextElementSibling;
        }

        let targetWidth = this.getTargetPageWidth(pages);
        let totalHeight = 0;
        let width = 0;

        pages.forEach(page => {
            let scale = this.getPageScale(page.width, targetWidth);
            let renderWidth = page.width * scale;
            let renderHeight = page.height * scale;

            this.renderPage(page, images, {
                offsetY: totalHeight,
                scale
            });

            totalHeight += renderHeight;
            width = Math.max(width, renderWidth);
        });

        this.layoutSvg.setAttribute('viewBox', `0 0 ${width} ${totalHeight}`); // TODO: handle missing bbox (use image dimensions then)

        // this.layoutBackground = this.createSvgElem('rect', {'class': 'background', 'x': 0, 'y': totalHeight, 'width': '100%', 'height': '100%', 'style': 'fill: none'});
        // this.layoutBackground = this.createSvgElem('rect', {'class': 'background', 'x': 0, 'y': totalHeight, 'width': '100%', 'style': 'fill: none'});
        // this.layoutSvg.appendChild(this.layoutBackground);
    }

    getPageMetrics(pageNode) {
        let pageOptions = this.getNodeOptions(pageNode);
        let top = parseInt(pageOptions.bbox[1], 10) || 0;
        let width = parseInt(pageOptions.bbox[2], 10) || 1;
        let height = parseInt(pageOptions.bbox[3], 10) || 1;

        return {
            node: pageNode,
            image: pageOptions.image,
            top,
            width: Math.max(width, 1),
            height: Math.max(height, 1)
        };
    }

    getTargetPageWidth(pages) {
        if (!pages || pages.length === 0)
            return 1;

        let widths = pages
            .map(page => page.width)
            .filter(width => width > 0)
            .sort((a, b) => a - b);

        if (widths.length === 0)
            return 1;

        return widths[Math.floor(widths.length / 2)];
    }

    getPageScale(width, targetWidth) {
        if (!width || !targetWidth)
            return 1;

        if (width <= targetWidth * this.pageWidthOutlierRatio)
            return 1;

        return targetWidth / width;
    }

    setZoom(zoom) {
        if (zoom === 'page-full') {
            this.layoutSvg.style.width = null;
            this.layoutSvg.style.height = null;
            this.layoutSvg.style.maxWidth = '100%';
            this.layoutSvg.style.maxHeight = '100%';
        } else if (zoom === 'page-width') {
            this.layoutSvg.style.width = null;
            this.layoutSvg.style.height = null;
            this.layoutSvg.style.maxWidth = '100%';
            this.layoutSvg.style.maxHeight = null;
        } else if (zoom === 'original') {
            this.layoutSvg.style.width = '2480px'; // TODO: use bounding box of ocr_page here
            this.layoutSvg.style.height = '3508px'; // TODO: use bounding box of ocr_page here
            this.layoutSvg.style.maxWidth = null;
            this.layoutSvg.style.maxHeight = null;
        }
    }
    // HocrProofreader.prototype.toggleLayoutImage = function () {
    //     if (!this.layoutWords.style.display || this.layoutWords.style.display === 'block') {
    //         this.layoutWords.style.display = 'none';
    //         this.layoutImage.style.display = 'block';
    //     } else {
    //         this.layoutWords.style.display = 'block';
    //         this.layoutImage.style.display = 'none';
    //     }
    // };

    renderPage(page, images, layout) {
        this.layoutContainer.scrollTop = 0;
        this.layoutContainer.scrollLeft = 0;

        // TODO: remove linkedNode attributes to avoid memleaks
        // this.removeChildren(this.layoutWords);
        // this.removeChildren(this.layoutRects);
        if (!page) {
            // TODO: hide completely? reset image/font/viewBox/...?
            return;
        }

        let pageTransform = `translate(0 ${layout.offsetY - (page.top * layout.scale)}) scale(${layout.scale})`;
        let imageGroup = this.createSvgElem('g', { 'transform': pageTransform });
        let rectGroup = this.createSvgElem('g', { 'transform': pageTransform });

        let image = this.createSvgElem('image', { 'x': 0, 'y': page.top, 'width': page.width, 'height': page.height });
        image.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', images[page.image]);
        imageGroup.appendChild(image);

        this.layoutImages.appendChild(imageGroup);
        this.layoutRects.appendChild(rectGroup);
        this.renderNodesRecursive(page.node, null, rectGroup);
    }

    renderNodesRecursive(node, options, parentRectsNode) {
        if (!parentRectsNode)
            parentRectsNode = this.layoutRects;

        let className = null;
        if (node.classList.contains('ocr_carea')) {
            className = 'ocr_carea';
        } else if (node.classList.contains('ocr_par')) {
            className = 'ocr_par';
        } else if (node.classList.contains('ocr_line')) {
            className = 'ocr_line';
        } else if (node.classList.contains('ocrx_word')) {
            className = 'ocrx_word';
        }

        if (className) {
            if (className !== 'ocrx_word') {
                var groupNode = this.createSvgElem('g', { 'class': className, 'id': node.id });
                parentRectsNode.appendChild(groupNode);
                parentRectsNode = groupNode;
            }

            options = this.inheritOptions(this.getNodeOptions(node), options);

            if (options.bbox) {
                if (className === 'ocrx_word' && options.baselineBbox) {
                    var word = node.textContent;

                    // TODO: calculate font-size and y based on bbox, not baseline (font-metrics needed):
                    // var textNode = this.createSvgElem('text', {
                    //     'x': options.bbox[0],
                    //     'y': parseFloat(options.baselineBbox[3]) + parseFloat(options.baseline[1]),
                    //     'font-size': options.x_fsize * /* TODO: options.scan_res[1] */ 300 / 72, // 1 pt = 1/72 inch
                    //     'textLength': options.bbox[2] - options.bbox[0],
                    //     'lengthAdjust': 'spacingAndGlyphs'
                    // });
                    // textNode.textContent = word;
                    // this.layoutWords.appendChild(textNode);
                }

                var rectNode = this.createSvgElem('rect', {
                    'x': options.bbox[0],
                    'y': options.bbox[1],
                    'width': options.bbox[2] - options.bbox[0],
                    'height': options.bbox[3] - options.bbox[1],
                    'class': className,
                    'id': node.id
                });

                // console.log("Will add node of: " + node.id + " " + options.bbox);
                parentRectsNode.appendChild(rectNode);

                // cross-link both nodes:
                rectNode.linkedNode = node;
                node.linkedNode = rectNode;
            }
        }

        var childNode = node.firstElementChild;
        while (childNode) {
            this.renderNodesRecursive(childNode, options, parentRectsNode);
            childNode = childNode.nextElementSibling;
        }
    }

    getNodeOptions(node) {
        var asArray = ['bbox', 'baseline'];
        var optionsStr = node.title ? node.title : '';
        var match, regex = /(?:^|;)\s*(\w+)\s+(?:([^;"']+?)|"((?:\\"|[^"])+?)"|'((?:\\'|[^'])+?)')\s*(?=;|$)/g;

        var options = {};
        while (match = regex.exec(optionsStr)) {
            var name = match[1];
            var value = match[4] || match[3] || match[2];

            if (asArray.indexOf(name) !== -1) {
                value = value.split(/\s+/);
            }

            options[name] = value;
        }

        return options;
    }

    inheritOptions(options, parentOptions) {
        var inheritableOptions = ['baseline', 'baselineBbox'];

        // baseline is relative to the bbox of the node where the baseline is defined, so we have to remember this bbox:
        if ('baseline' in options && 'bbox' in options) {
            options.baselineBbox = options.bbox;
        }

        if (parentOptions) {
            for (let name in parentOptions) {
                if (inheritableOptions.indexOf(name) === -1)
                    continue;
                if (name in options)
                    continue;
                options[name] = parentOptions[name];
            }
        }

        return options;
    }

    onHover(target, isEditorContainer) {
        if (target === this.hoveredNode)
            return;

        if (this.hoveredNode) {
            this.hoverTreeNodes(this.hoveredNode, false);
            this.hoverTreeNodes(this.hoveredNode.linkedNode, false);
            this.hoveredNode = null;
        }

        if (isEditorContainer) {
            // check for page change:
            var pageNode = target;
            while (pageNode && (!pageNode.classList.contains('ocr_page'))) {
                pageNode = pageNode.parentElement;
            }
            if (pageNode && pageNode !== this.currentPage) {
                var backwards = false, tmpNode = this.currentPage;
                while (tmpNode) {
                    tmpNode = tmpNode.previousElementSibling;
                    if (tmpNode === pageNode) {
                        backwards = true;
                        break;
                    }
                }

                this.currentPage = pageNode;
                this.renderCurrentPage(backwards);
            }
        }

        var linkedNode = target && target.linkedNode;
        if (linkedNode) {
            this.hoverTreeNodes(target, true);
            this.hoverTreeNodes(linkedNode, true);
            this.hoveredNode = target;

            var linkedContainer = isEditorContainer ? this.layoutContainer : this.editorIframe.contentDocument.documentElement;
            this.scrollIntoViewIfNeeded(linkedNode, linkedContainer);
        }
    }

    hoverTreeNodes(node, isActive) {
        while (node) {
            if (node.classList.contains('ocr_page') || node.classList.contains('rects'))
                break;
            if (isActive) {
                node.classList.add('hover');
            } else {
                node.classList.remove('hover');
            }
            node = node.parentElement;
        }
    }

    scrollIntoViewIfNeeded(node, scrollParentNode) {
        var rect = node.getBoundingClientRect();
        // do not substract the bounding-rect of the scrollParent if it is the documentElement (e.g. the iframe),
        // otherwise scroll-position is added twice - set to 0:
        var parentRect = scrollParentNode.parentElement ? scrollParentNode.getBoundingClientRect() : { left: 0, top: 0 };
        var nodeRect = {
            left: rect.left - parentRect.left + scrollParentNode.scrollLeft,
            top: rect.top - parentRect.top + scrollParentNode.scrollTop,
            right: rect.right - parentRect.left + scrollParentNode.scrollLeft,
            bottom: rect.bottom - parentRect.top + scrollParentNode.scrollTop
        };

        if (nodeRect.bottom > scrollParentNode.scrollTop + scrollParentNode.clientHeight) {
            node.scrollIntoView({ behavior: 'smooth', block: 'end' });
        } else if (nodeRect.right > scrollParentNode.scrollLeft + scrollParentNode.clientWidth) {
            node.scrollIntoView({ behavior: 'smooth', block: 'end' });
        } else if (nodeRect.top < scrollParentNode.scrollTop) {
            node.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (nodeRect.left < scrollParentNode.scrollLeft) {
            node.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
}













// WEBPACK FOOTER //
// ./src/helpers/HocrProofreader.js